<template>
    <section class="content">
        <div class="container-fluid">

            <div class="row">

                <div class="col-sm-12">  
                    <div class="card">
                        <div class="card-header">
                            <div class="row">                                                   
                                <div class="col">
                                    <h5>Ads Chart</h5>
                                </div>
                            </div>
                        </div>
                        <div class="card-block">
                            <!-- Row start -->
                            <div>
                                <canvas id="chart-container" height="80">
                                    Charts will render here
                                </canvas>
                            </div>
                            <!-- Row end -->
                        </div>
                    </div>
                </div> 
            </div>
        </div>
    </section>
</template>

<script>
    import Chart from 'chart.js/auto';
    import { getRelativePosition } from 'chart.js/helpers';
    import ChartDataLabels from 'chartjs-plugin-datalabels';
    import moment from 'moment'
   
    export default {
        data () {
            return {
              adsCahrt: {},
            }
        },
        methods: {
            getParameterByName(name, url) {
                if (!url) url = window.location.href;
                name = name.replace(/[\[\]]/g, "\\$&");
                var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                    results = regex.exec(url);
                if (!results) return null;
                if (!results[2]) return '';
                return decodeURIComponent(results[2].replace(/\+/g, " "));
            },
            getAds() {
                Chart.register(ChartDataLabels);

                var sDate = this.getParameterByName('sdate');
                var eDate = this.getParameterByName('edate');
                if( !sDate ){
                    sDate = moment().utcOffset("-05:00").format('YYYY-MM-DD');
                }
                if( !eDate ){
                    eDate = moment().utcOffset("-05:00").format('YYYY-MM-DD');
                }

                const ctx = document.getElementById('chart-container');

                axios.post("api/v1/ads", {
                            'start_date': sDate,
                            'end_date': eDate
                        }
                    ).then(({ data }) => { 
                    const chart = new Chart(ctx, {
                    type: 'bar',
                    data: {
                        labels: data.data.ad_groups,
                        datasets: [
                            {
                                label: "Bing spend, ($"+Math.round(data.data.total.bing)+")",
                                backgroundColor: "#3e95cd",
                                data: data.data.bing,
                            },
                            {
                                label: "Google spend, ($"+Math.round(data.data.total.google)+")",
                                backgroundColor: "#3cba9f",
                                data: data.data.google,
                            }
                        ]
                    },
                    options: {
                        plugins: {
                            title: {
                                display: true,
                                text: ["Last Update", "Google : "+data.data.last_update.google ,"    Bing : "+data.data.last_update.bing],
                                padding: {
                                    top: 10,
                                    bottom: 30
                                }
                            },
                            datalabels: {
                                anchor: 'end',
                                align: 'top',
                                formatter: function(value) {
                                  return Math.round(value) + " $";
                                },
                                font: {
                                    weight: 'bold'
                                },
                                color: "#000000"
                            }
                        },
                        legend: {
                            display: true,
                            labels: {
                                fontStyle: 'bold'
                            }
                        }
                    }
                });

                }).catch((data)=> {
                     Swal.fire("Failed!", data.message, "warning");
                });
            },
        },
        mounted() {
            this.getAds();
        },
        created() {
        }
    }
</script>